import { render, staticRenderFns } from "./CompanyAuth.vue?vue&type=template&id=395f86b5&scoped=true&"
import script from "./CompanyAuth.vue?vue&type=script&lang=js&"
export * from "./CompanyAuth.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAuth.vue?vue&type=style&index=0&id=395f86b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395f86b5",
  null
  
)

export default component.exports